import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import ContactInfo from './components/ContactInfo';

export default function About() {
  return (
    <>
      <SEOHead
        title="关于我们 - 品牌介绍与联系方式"
        description="果冻传媒成立于2015年，专注创意内容生产与品牌传播，拥有200+专业人才。了解果冻传媒的品牌故事、核心团队、发展历程与客户口碑，获取联系方式与合作方案。"
        keywords="果冻传媒关于我们,果冻传媒联系方式,果冻传媒团队介绍,果冻传媒品牌故事"
        canonicalUrl="https://www.guodongmedia.com/about"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '关于果冻传媒 - 创意内容营销与品牌传播平台',
            description: '了解果冻传媒的品牌故事、核心团队、发展历程与客户口碑。',
            url: 'https://www.guodongmedia.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '果冻传媒',
              url: 'https://www.guodongmedia.com',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.guodongmedia.com/' },
              { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.guodongmedia.com/about' },
            ],
          }),
        }}
      />
      <main>
        <div className="pt-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
            <div className="py-10 md:py-14 text-center">
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-4">
                关于果冻传媒
              </h1>
              <p className="text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                从2015年创立至今，果冻传媒始终专注一件事——用创意连接品牌与消费者
              </p>
            </div>
          </div>
        </div>
        <BrandIntro />
        <Reputation />
        <ContactInfo />
      </main>
    </>
  );
}